import styled from 'styled-components'
import {
  Business as BaseBusiness,
  BusinessCenter as BaseBusinessCenter,
  Check as BaseCheck,
  Lock as BaseLock,
  Mail as BaseMail,
  Person as BasePerson
} from '@material-ui/icons'

export const BusinessIcon = styled(BaseBusiness)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const BusinessCenterIcon = styled(BaseBusinessCenter)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const CheckIcon = styled(BaseCheck)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const LockIcon = styled(BaseLock)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const MailIcon = styled(BaseMail)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`

export const PersonIcon = styled(BasePerson)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    font-size: ${props => props.size};
  }
`
